export const mockData = {
  hero: {
    headline: "Securing the Code.Defending the Perimeter.",
    subheadline: "AYAN BHOWAL — Product Security Engineer",
    cta: "Initialize Portfolio"
  },
  skills: [
    {
      id: 1,
      category: "AppSec",
      icon: "Shield", 
      color: "green",
      items: ["OWASP Top 10", "SAST/DAST (CodeQL)", "Threat Modeling (STRIDE)", "API Security"]
    },
    {
      id: 2,
      category: "Cloud & Compliance",
      icon: "Cloud", 
      color: "blue",
      items: ["Azure Sentinel", "HIPAA Compliance", "Secure SDLC", "Cloud Security"]
    },
    {
      id: 3,
      category: "DevSecOps",
      icon: "Workflow", 
      color: "green",
      items: ["CI/CD Integration", "Python Automation", "Container Security", "Security Testing"]
    },
    {
      id: 4,
      category: "SOC Operations",
      icon: "Activity", /* CHANGED from Terminal */
      color: "blue",
      items: ["Incident Response", "Malware Analysis", "Threat Intelligence", "SIEM Management"]
    },
    {
      id: 5,
      category: "Vulnerability Management",
      icon: "Bug", /* CHANGED from Terminal */
      color: "green",
      items: ["Penetration Testing (VAPT)", "Risk Assessment & Scoring", "Remediation Tracking", "Security Reporting"]
    },
    {
      id: 6,
      category: "Network & Cryptography",
      icon: "Lock", /* CHANGED from Terminal */
      color: "blue",
      items: ["Network Traffic Analysis", "Applied Cryptography (AES/Twofish)", "Packet Inspection (Scapy)", "Endpoint Security (EDR)"]
    }
  ],
  socDashboard: {
    // --- KQL LOG DATA ---
    siemLogs: [
      { time: "15:34:24", code: "225", status: "Active", event: "Logon Success" },
      { time: "15:35:31", code: "225", status: "Active", event: "Suspicious Activity" },
      { time: "15:32:14", code: "210", status: "Active", event: "Suspicious Termination" },
      { time: "15:33:45", code: "220", status: "Active", event: "Policy Violation" }
    ],
    companies: [
      { name: "Wipro", role: "SOC Analyst", period: "2022-2023" },
      { name: "Harman India", role: "Security Operations", period: "2023-2024" }
    ],

    // --- CHART DATASETS ---
    
    // 1. VAPT: Severity Breakdown (Pie Chart)
    vulnSeverity: [
      { label: "Critical", value: 15, color: "#D32F2F" }, 
      { label: "High", value: 30, color: "#F57C00" },   
      { label: "Medium", value: 45, color: "#FFB300" },  
      { label: "Low", value: 10, color: "#4CAF50" }     
    ],

    // 2. SOC: Alerts over Time (Bar Chart)
    alertVolume: [
      { time: "00:00", count: 12 }, { time: "04:00", count: 5 }, 
      { time: "08:00", count: 45 }, { time: "12:00", count: 80 }, 
      { time: "16:00", count: 65 }, { time: "20:00", count: 30 }
    ],
    
    recentThreats: [
      { type: "Phishing Attempt", source: "Email Gateway", action: "Blocked", time: "10:42 AM" },
      { type: "Malware Beacon", source: "Endpoint (EDR)", action: "Isolated", time: "09:15 AM" },
      { type: "Brute Force", source: "Azure AD", action: "Locked", time: "08:30 AM" }
    ],

    // 3. AppSec: Top Vulnerability Types (Horizontal Bar)
    vulnTypes: [
      { type: "SQL Injection", count: 12 },
      { type: "XSS (Reflected)", count: 28 },
      { type: "Broken Access", count: 18 },
      { type: "Insecure Deserialization", count: 7 }
    ],
    
    pipelineStats: [
      { stage: "DESIGN", tool: "Threat Model", metric: "0 Design Flaws" },
      { stage: "CODE", tool: "SAST / CodeQL", metric: "15 Bugs Fixed" },
      { stage: "BUILD", tool: "SCA / DepCheck", metric: "Clean Libs" },
      { stage: "TEST", tool: "DAST / Burp", metric: "Vuln Verified" }
    ],

    // 4. Cloud: Compliance breakdown (Donut)
    cloudCompliance: [
      { label: "Passing", value: 85, color: "#00FF41" },
      { label: "Failed", value: 5, color: "#D32F2F" },
      { label: "Warning", value: 10, color: "#FFB300" }
    ],
    cloudPosture: [
      { name: "Azure Sentinel", score: 92 },
      { name: "HIPAA Compliance", score: 98 },
      { name: "IAM / Access Control", score: 100 }
    ]
  },
  projects: [
    {
      id: 1,
      title: "Malware Analysis & Incident Response – SOC Case Study",
      description: "Comprehensive root cause analysis and attack path mapping for enterprise incidents. Utilized reverse engineering techniques and sandbox analysis.",
      tech: ["IDA Pro", "Wireshark", "YARA", "VirusTotal"],
      github: "https://github.com/Bhowal19/Malware-Incident-Response-Case-Study",
      image: "malware"
    },
    {
      id: 2,
      title: " Windows Encryption Application-Cryptographic Algorithm Analyser",
      description: "Python-based encryption tool implementing AES and Twofish algorithms with performance benchmarking and security analysis.",
      tech: ["Python", "Cryptography", "AES", "Twofish"],
      github: "https://github.com/Bhowal19/Encryption-Application-Using-Modern-Cryptographic-Techniques",
      image: "crypto"
    },
    {
      id: 3,
      title: "Network Traffic Analysis & Keylogger",
      description: "Packet inspection tool using Scapy for deep network analysis, protocol dissection, and security research purposes.",
      tech: ["Python", "Scapy", "Wireshark", "PCAP"],
      github: "https://github.com/Bhowal19/Keylogger-Packet-Sniffer",
      image: "network"
    }
  ],
  articles: [
    {
      id: 1,
      title: "League of Legends: A Product Security Wake-Up Call",
      date: "2024-02-15",
      readTime: "8 min read",
      category: "Case Study",
      mediumUrl: "https://medium.com/@ayanbhowal",
      excerpt: "Analyzing the 2025 breach and its implications for gaming industry security."
    },
    {
      id: 2,
      title: "What Is Product Security?",
      date: "2024-01-20",
      readTime: "6 min read",
      category: "Fundamentals",
      mediumUrl: "https://medium.com/@ayanbhowal",
      excerpt: "A comprehensive guide to understanding product security in modern software development."
    },
    {
      id: 3,
      title: "Navigating the Porter Data Breach",
      date: "2023-12-10",
      readTime: "10 min read",
      category: "Incident Analysis",
      mediumUrl: "https://medium.com/@ayanbhowal",
      excerpt: "Lessons learned from the Porter incident and how to prevent similar breaches."
    }
  ],
  contact: {
    email: "bhowal.ayan2002@gmail.com",
    linkedin: "https://www.linkedin.com/in/ayan-bhowal/",
    github: "https://github.com/Bhowal19",
    behance: "https://www.behance.net/ayanbhowal",
    twitter: "https://x.com/AyanBhowal8",
    youtube: "https://www.youtube.com/@CyberSecShorts",
    status: "online"
  }
};